import React from 'react';
import { Lightbulb, ArrowUpRight } from 'lucide-react';

/**
 * HomeKeyInsight — dark, cyan-edged insight card. The whole block
 * (eyebrow + insight text + optional metric) is vertically centred so
 * the card fills its row height as one balanced group with no empty
 * band. When onMetricClick is provided the metric deep-links to the
 * weakest stage's health dashboard.
 */
export default function HomeKeyInsight({ text, metric, onMetricClick }) {
  const clickable = !!(metric && onMetricClick);
  const MetricInner = (
    <>
      <div className="flex items-center justify-between gap-2">
        <div className="text-[10px] uppercase tracking-wider text-slate-500">{metric?.label}</div>
        {clickable && <ArrowUpRight className="h-3.5 w-3.5 text-[#44b6d2] shrink-0" />}
      </div>
      <div className="flex items-baseline gap-2 mt-0.5">
        <span className={`text-2xl font-heading font-extrabold tabular-nums ${metric?.tone || 'text-slate-100'}`}>{metric?.value}</span>
        {metric?.sub && <span className="text-xs font-semibold text-slate-400">{metric.sub}</span>}
      </div>
    </>
  );
  return (
    <div
      className="lg:col-span-3 rounded-2xl bg-[#111827] ring-1 ring-[#1f2a44] border-l-4 border-[#44b6d2] p-5 shadow-xl flex flex-col justify-center"
      data-testid="home-key-insight"
    >
      <div className="flex items-center gap-2">
        <Lightbulb className="h-4 w-4 text-[#44b6d2]" />
        <p className="text-[11px] font-bold uppercase tracking-[0.16em] text-[#44b6d2]">Key Insight</p>
      </div>
      <p className="text-sm text-slate-200 leading-relaxed mt-3" data-testid="home-key-insight-text">
        {text}
      </p>
      {metric && (
        clickable ? (
          <button
            type="button"
            onClick={onMetricClick}
            className="mt-4 pt-3 border-t border-[#1f2a44] text-left rounded-b-lg -mx-1 px-1 hover:bg-white/[0.03] transition-colors group/metric"
            data-testid="home-key-insight-metric"
            title="Open the weakest stage's health dashboard"
          >
            {MetricInner}
            <span className="mt-1 block text-[10px] font-semibold uppercase tracking-wider text-[#44b6d2] opacity-0 group-hover/metric:opacity-100 transition-opacity">
              View stage health →
            </span>
          </button>
        ) : (
          <div className="mt-4 pt-3 border-t border-[#1f2a44]" data-testid="home-key-insight-metric">
            {MetricInner}
          </div>
        )
      )}
    </div>
  );
}
